import { DateRange, RangeOptionType } from '@enter/core';
import { PageLayoutRow, PageLayoutTitle } from '../page-layout';
import { inject, observer } from 'mobx-react';
import React from 'react';
import { DateRangeType, IInjectedRootStore } from '../../stores';
import { SettingsButton } from '../settings-button';
import * as S from './page-header.styles';

interface IPageHeaderProps {
    title: string;
    /**
     * One line under the title saying what the screen is for.
     *
     * Optional, and inert when absent: without it the header renders exactly the markup it
     * rendered before, because `S.Header` is a flex row that every page in the app goes
     * through (71 symbols reach this component upstream) and a wrapper added unconditionally
     * would re-lay-out all of them.
     */
    subtitle?: string;
    /**
     * Page-level actions, at the right of the header before the settings button — where the
     * support console puts "New payer" (FE-79).
     *
     * Optional and inert when absent, for the same reason as `subtitle`: nothing extra renders, so
     * every other page's header keeps its exact markup.
     */
    actions?: React.ReactNode;
    hideDateRange?: boolean;
    children?: React.ReactNode;
}

@inject('rootStore')
@observer
export class PageHeader extends React.Component<IPageHeaderProps> {
    public render(): React.ReactElement {
        return (
            <PageLayoutRow>
                <S.Header>
                    {this.props.subtitle ? (
                        <S.TitleBlock>
                            <PageLayoutTitle>{this.props.title}</PageLayoutTitle>
                            <S.Subtitle>{this.props.subtitle}</S.Subtitle>
                        </S.TitleBlock>
                    ) : (
                        <PageLayoutTitle>{this.props.title}</PageLayoutTitle>
                    )}
                    {this.showDateRange && (
                        <>
                            {/* <S.WrappedDateRange>
                                <DateRange
                                    selectedOptionType={this.currentDateRangeOption}
                                    startDate={this.currentDateRange[0]}
                                    endDate={this.currentDateRange[1]}
                                    onChange={this.handleDateRangeChange}
                                />
                            </S.WrappedDateRange> */}
                            <S.ChildrenWrapper>{this.props.children}</S.ChildrenWrapper>
                            {/* <S.WrappedDateTypeSelect
                                value={this.currentDateRangeType}
                                onChange={this.handleSelectChange}
                            /> */}
                        </>
                    )}
                    <S.Spacer />
                    {this.props.actions && <S.Actions>{this.props.actions}</S.Actions>}
                    <SettingsButton />
                </S.Header>
            </PageLayoutRow>
        );
    }
    private get injected(): IInjectedRootStore {
        return this.props as IPageHeaderProps & IInjectedRootStore;
    }
    private get showDateRange(): boolean {
        return !this.props.hideDateRange;
    }
    private get currentDateRange(): [Date, Date] {
        return this.injected.rootStore.dateRangeStore.dateRange;
    }
    private get currentDateRangeOption(): RangeOptionType {
        return this.injected.rootStore.dateRangeStore.dateRangeOption;
    }
    private get currentDateRangeType(): DateRangeType {
        return this.injected.rootStore.dateRangeStore.dateRangeType;
    }
    private readonly handleDateRangeChange = (dateRange: [Date, Date], option: RangeOptionType): void => {
        this.injected.rootStore.dateRangeStore.setDateRange(dateRange);
        this.injected.rootStore.dateRangeStore.setDateRangeOption(option);
    };
    private readonly handleSelectChange = (type: DateRangeType): void => {
        this.injected.rootStore.dateRangeStore.setDateRangeType(type);
    };

}
